if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.viewer = this.querySelector('[id^="GalleryViewer"]');
        this.thumbnails = this.querySelector('[id^="GalleryThumbnails"]');

        this.viewer?.addEventListener('slideChanged', this.onSlideChanged.bind(this));
        this.thumbnails?.addEventListener('click', this.onThumbnailClick.bind(this));
      }

      onThumbnailClick(event) {
        const button = event.target.closest('button.thumbnail');
        if (!button) return;

        const thumbnail = button.closest('[data-target]');
        if (!thumbnail?.dataset.target) return;

        event.preventDefault();
        this.setActiveMedia(thumbnail.dataset.target, false);
      }

      onSlideChanged(event) {
        const mediaId = event.detail?.currentElement?.dataset?.mediaId;
        if (mediaId) this.setActiveThumbnail(mediaId);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia || !this.viewer?.slider) return;

        this.querySelectorAll('[data-media-id]').forEach((media) => media.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        if (prepend) {
          this.viewer.slider.prepend(activeMedia);
          this.viewer.resetPages?.();
        }

        this.viewer.setSlidePosition?.(activeMedia.offsetLeft);
        this.setActiveThumbnail(mediaId);
      }

      setActiveThumbnail(mediaId) {
        if (!this.thumbnails) return;

        this.thumbnails.querySelectorAll('button.thumbnail[aria-current="true"]').forEach((button) => {
          button.removeAttribute('aria-current');
        });

        const activeThumbnail = this.thumbnails.querySelector(`[data-target="${mediaId}"] button.thumbnail`);
        if (!activeThumbnail) return;

        activeThumbnail.setAttribute('aria-current', 'true');
        activeThumbnail.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
        });
      }
    }
  );
}
